export const state = {};
export const getter = {};
export const actions = {};
export const mutations = {};



// WEBPACK FOOTER //
// ./src/pages/home/mine/message/store.js